import { render, staticRenderFns } from "./AccommodationsReview.vue?vue&type=template&id=62fade51&scoped=true&"
import script from "./AccommodationsReview.vue?vue&type=script&lang=js&"
export * from "./AccommodationsReview.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationsReview.vue?vue&type=style&index=0&id=62fade51&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fade51",
  null
  
)

export default component.exports